export * from './People1EditIcon';
export * from './People1EditIcon16Light';
export * from './People1EditIcon16Regular';
export * from './People1EditIcon16Solid';
export * from './People1EditIcon20Light';
export * from './People1EditIcon20Regular';
export * from './People1EditIcon20Solid';
export * from './People1EditIcon24Regular';
export * from './People1EditIcon24Solid';
export * from './People1EditIcon32Regular';
export * from './People1EditIcon64Regular';
